import { FC } from 'react';
import { Content } from '@styles/Admin-tools/Roles/RoleModalStyles';
import { useToggle } from '@shared/hooks/useToggle';
import { SelectableListItem } from './SelectableListItem';

interface ISelectableCollapseProps {
  checked?: boolean;
  text: string;
  children?: JSX.Element | JSX.Element[] | null;
  open?: boolean;

  onChange?(): void;
}

export const SelectableCollapse: FC<ISelectableCollapseProps> = ({ checked, text, children, onChange, open }) => {
  const [isOpen, setOpen] = useToggle(open);

  return (
    <>
      <SelectableListItem text={text} open={isOpen} checked={checked} onToggle={setOpen} onSelectionChange={onChange} />

      <Content unmountOnExit in={isOpen}>
        {children}
      </Content>
    </>
  );
};
